export default __webpack_public_path__ + "static/media/home-2_1.ba46cbb7.gif";